import { PropertyType } from '../../../models/enum';

export const Dashboard = {
    modelName: 'dashboardGuid',
    propertyType: PropertyType.DashboardSelector,
    label: 'Dashboard',
    propertyName: 'dashboardGuidProperty',
    required: false,
    icon: 'fa-th-large',
    extraData: {
        addNone: true
    }
};